<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" title="申请开票" :visible.sync="dialogVisible" destroy-on-close width="800px">
		<div>
			<el-form ref="formRef" :model="formData" :rules="rules" label-position="top" label-width="120px">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="发票信息：" prop="invoiceId">
							<el-select v-model="formData.invoiceId" placeholder="请选择" filterable style="width: 100%">
								<el-option v-for="item in invoiceList" :key="item.id" :label="item.invoiceTitle" :value="item.id" />
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="24">
						<el-button icon="el-icon-refresh" type="text" @click="getCorporateGetInvoice" style="margin-right: 10px">刷新</el-button>
						<el-button icon="el-icon-add" type="text" @click="handleAddInvoice">发票管理</el-button>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="24">
						<p style="color: #475569; font-size: 14px; font-weight: normal; margin-top: 0; line-height: 22px">说明：本平台所销售图书由北京品读文化发展有限公司开具增值税普通发票（电子发票）</p>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="handleClose">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm"> 提交 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
	import { postConsumerOrderInvoice } from '@/api/order/order';
	import { getCorporateGetInvoice } from '@/api/user/invoice.js';
	import Y from '@/utils/Y';
	export default {
		name: 'DialogInvoiceApply',
		props: {
			tradeNo: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				dialogVisible: false,
				invoiceList: [],
				formData: {
					invoiceId: '',
					tradeNo: this.tradeNo,
					invoiceType: 2
				},
				rules: {
					invoiceId: [{ required: true, message: '请选择发票信息', trigger: 'change' }]
				}
			};
		},
		created() {
			this.getCorporateGetInvoice();
		},
		methods: {
			//获取发票列表
			async getCorporateGetInvoice() {
				const res = await getCorporateGetInvoice({});
				this.invoiceList = res.data.rows;
			},
			handleClose() {
				this.resetForm();
				this.dialogVisible = false;
			},

			handleAddInvoice() {
				const targetRoute = this.$router.resolve({
					path: '/UserCenter/UserInvoice'
				});
				window.open(targetRoute.href, '_blank');
			},

			resetForm() {
				this.$refs['formRef'].resetFields();
			},

			handleConfirm() {
				this.$refs['formRef'].validate(valid => {
					if (valid) {
						this.formData.tradeNo = this.tradeNo;
						postConsumerOrderInvoice(this.formData)
							.then(res => {
								Y.msg.success('开票申请成功！');
								this.handleClose();
								this.$emit('confirm');
							})
							.catch(err => {
								Y.msg.error(err.message);
							});
					}
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	// 弹出框重置样式
	/deep/ .el-dialog__header {
		border-bottom: 1px dashed #e2e8f0;
		margin-right: 0;
		background: #f8fafc;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #3a434f;
		font-size: 24px;
	}

	/deep/ .el-dialog__footer {
		border-top: 1px solid #e8e8e8;
		padding: 18px;
	}

	/deep/ .el-dialog__body .el-form-item__label {
		line-height: 26px;
	}
</style>
